import styled from 'styled-components'

export const ErrorMessage = styled.p`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  margin: 4px 0 0;
  color: #cf1322;
  font-family: Roboto, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;

  svg {
    flex-shrink: 0;
    width: 12px;
    height: 12px;
    margin-top: 2px;
    font-size: 12px;
  }
`
